<!-- 企业动态 -->

<template>
    <div class="content" style="padding: 0;">
        <cx-head v-if="windowWidth <= 768" />
        <b-container fluid>
        	<img class="top_img" width="100%"
        		:src="windowWidth >= 768 ? '../../static/img/view/top_img.jpg' : '../../static/img/view/top_img.jpg'" />
        </b-container>
   <!--     <div style="padding: 150px 50px 0;font-size: 20px;">

          <div>
            公司地址：北京市通州区张家湾镇光华路
          </div>
          <div>
            长沙办公地址：长沙开福区马栏山视频文创产业园视谷中心10楼
          </div>
        </div> -->




    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import api from '../api/api.js';
import cxHead from '@/components/cx-head.vue';
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {
        cxHead,
    },
    metaInfo() {
        return {
            title: this.pageName, // set a title
            meta: [
                {
                    // set meta
                    name: 'keyWords',
                    content: this.SeoKeyword,
                },
                {
                    name: 'description',
                    content: this.SeoDescription,
                },
            ],
        };
    },
    data() {
        //这里存放数据
        return {
            windowWidth: window.innerWidth,
            loading: true,
            pageName: '',
            SeoKeyword: '',
            SeoDescription: '',
            i: 0,
            type: 'audio',
            mianbaoList: [
                {
                    text: '首页',
                    href: '/',
                },
                {
                    text: '媒体',
                    href: 'media',
                },
                {
                    text: '企业动态',
                    // href: '/',
                    active: true,
                },
            ],
            newList: [],
            pageCur: 1,
            n: -1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        nameId(index) {
            return 'id' + index;
        },
        playVedio(id, index) {
            // console.log(id)
            this.n = index;
            // this.mp4 = '../../static/mp4/2.mp4';
            // this.$set(this.mp4, 0, '../../static/mp4/2.mp4');
            var video = document.querySelector('#' + id);
            video.play();
        },
        stopPlay(id) {
            // console.log(id)
            this.n = -1;
            // this.mp4 = '../../static/mp4/2.mp4'
            var video = document.querySelector('#' + id);
            // video.stop();
            video.pause();

        },

        formatDate(date) { //格式化日期
            if (date) {
                let date1 = new Date(date.replace(/-/g, '/'));
                date = this.common.formatDate(new Date(date1), 'yyyy年MM月dd日');
            }
            return date;
        },

        splitImg(imgStr) {
            if (imgStr) {
                let imgList = imgStr.split(',');
                return imgList[0]
            } else {
                return ''
            }
        },
        getSiteData() {
            //获取seo关键字
            let that = this;
            that.$axios
                .post(api.GetSiteData, {})
                .then(function (response) {
                    // console.log('seo优化', response);
                    let data = response.data;
                    that.pageName = data.Title ? data.Title : '约你游·一站式房车旅游综合服务平台';
                    that.SeoKeyword = data.SeoKeyword ? data.SeoKeyword : '约你游·一站式房车旅游综合服务平台';
                    that.SeoDescription = data.SeoDescription
                        ? data.SeoDescription
                        : '约你游·一站式房车旅游综合服务平台';
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        getCompanyVisionData() {
            let that = this;
            this.$axios
                .post(api.GetCompanyVisionData, {
                    page: that.pageCur,
                    rows: 10
                })
                .then(function (response) {
                    console.log('初始数据', response);
                    that.newList = response.data.data;
                    that.loading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        getMoreData() {
            let that = this;
            that.pageCur++;
            this.$axios
                .post(api.GetCompanyVisionData, { page: that.pageCur, rows: 10 })
                .then(function (response) {
                    console.log('更多数据', response);
                    let data = response.data.data
                    if (data && data.length > 0) {
                        that.newList = that.newList.concat(data);
                    } else {
                        alert('没有更多数据了！')
                    }
                    // self.goodsList = self.goodsList.concat(res.Data);
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        gotoDetail(type, id, index) {
            // this.$router.push({
            // 	path: 'newsText',
            // 	query: { title: item.Title, date: item.CreateDate, textHtml: item.Content },
            // });
            if (type == 2) {
                this.playVedio(this.nameId(index), index)
            } else {
                this.$router.push({
                    path: '/viewDetail',
                    query: { id: id },
                });
            }
        }

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getCompanyVisionData();
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.getSiteData();
        const that = document
        setTimeout(()=>{
          that.body.scrollTop = 100; // chrome
          that.documentElement.scrollTop = 1000; // firefox
        },1000)

    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.content {
    padding-bottom: 90px;
    background-color: #f1f1f1;
}

.container-fluid {
    padding-left: 0 !important;
    padding-right: 0 !important;
}


.media_right {
    background-color: #fff;
    // border-bottom: 1px solid #f0eeef;
    flex: 1;
    // margin-right: 50px;
    text-align: start;
    // margin-left: 40px;
    margin-top: -20px;
    padding-top: 20px;
    border-radius: 0 0 20px 20px;
}

.newsTitle {
    color: #222;
    // font-weight: bold;
    font-size: 16px;
    text-align: left;
    padding: 0 12px;
    padding-bottom: 20px;
    // padding-bottom: 50px;
    // border-bottom: 1px solid #EEEEEE;
}

@media (max-width: 768px) {


    .title {
        margin: 0 12px;
    }

    .state_right {
        margin: 10px;
    }


    .media_right {
        margin-left: 0;
    }

    .newsTitle {
        padding-bottom: 12px;
        border-bottom: none;
    }

    .media_left {
        position: relative;
    }

    .play_btn {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 40px;
        height: 40px;
        margin-top: -20px;
        margin-left: -20px;
    }

    .newsDate {
        font-size: 14px;
        color: #0C8C69;
        background: url('../../static/img/view/date_bg2.png') no-repeat;
        width: 125px;
        height: 41px;
        background-size: 100% auto;
        background-position: center center;
        padding: 10px 6px;
        margin: 10px 0;
    }
}

.video_box {
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    text-align: center;

    .stopBtn {
        position: absolute;
        right: 20px;
        top: 60px;
        z-index: 2;
    }
}

.state_right {
    cursor: pointer;
}

@media (min-width: 768px) {
    .title {
        max-width: 1440px;
        text-align: left;
    }

    .media_state {
        margin: 40px auto;
        font-size: 14px;
        max-width: 1440px;
        width: 100%;

        .video_view {
            width: 100%;
            height: 100%;
            // margin-top: 200px;
        }

        .media_left {
            position: relative;
        }

        .play_btn {
            position: absolute;
            top: 50%;
            left: 50%;
            width: 40px;
            height: 40px;
            margin-top: -20px;
            margin-left: -20px;
        }

    }

    .state_view2 {
        margin: 0 auto;
    }

    .state_right {
        display: flex;
        width: 100%;
        max-width: 1440px;
        flex-wrap: wrap;
        margin: 0 auto;
        margin-top: 20px;
        padding: inherit;
        justify-content: space-between;
    }

    .media_view {
        width: 450px;
        cursor: pointer;
        margin-top: 10px;
        // margin-right: 30px;
    }

    .newsDate {
        font-size: 14px;
        color: #222;
        background: url('../../static/img/view/date_bg2.png') no-repeat;
        width: 140px;
        height: 41px;
        background-size: 100% auto;
        background-position: center center;
        padding: 10px 14px;
        margin: 20px 0;
    }

    .newsDate1 {
        font-size: 16px;
        color: #fff;
        background: url('../../static/img/view/date_bg1.png') no-repeat;
        width: 160px;
        height: 40px;
        background-size: 100% auto;
        background-position: center center;
        padding: 8px 14px;
        // margin: 20px 0;
    }

    .view_first {
        position: absolute;
        top: 200px;
        left: 130px;
        text-align: left;
        right: 130px;

        .text_view {
            color: #fff;
            margin-top: 30px;

        }
    }
}
</style>



// WEBPACK FOOTER //
// src/page/view.vue